import {Outlet, useNavigate} from "react-router-dom";
import React from "react";
import {useAppSelector} from "@src/integrations/redux/redux-store";
import {selectIsLoggedIn} from "@src/features/auth/redux/auth-slice";


export function RequireIsLoggedInLayout() {
	const navigate = useNavigate();
	
	const isLoggedIn = useAppSelector(selectIsLoggedIn);
	
	React.useEffect(() => {
		if (!isLoggedIn) {
			navigate("/auth/login");
		}
	}, [navigate, isLoggedIn]);
	
	if (!isLoggedIn) {
		return (
			<p>
				You need to log in in order to proceed.
			</p>
		);
	}
	
	return (
		<Outlet/>
	);
}
